import { Box } from '@mui/material';
import CoverageCheckbox from '../../../../../../../agencies/quotes/PrimeX/customizeQuote/components/CoverageCheckbox';
import SimpleTooltip from '../../../../../../../../components/SimpleTooltip';

interface RatingOptionLineItemNameProps {
  children: React.ReactNode;
  displayCheckBox?: boolean;
  isSelected?: boolean;
  onClick?: (isSelected: boolean) => void;
  supplementalInfo?: React.ReactNode;
}

const UWRatingOptionLineItemName = ({
  children,
  displayCheckBox = false,
  onClick = () => null,
  isSelected = false,
  supplementalInfo,
}: RatingOptionLineItemNameProps) => {
  return (
    <Box
      pl={displayCheckBox ? '0.5rem' : '1rem'}
      sx={{ width: '100%', minWidth: 0, overflow: 'hidden' }}
    >
      {displayCheckBox ? (
        <Box
          onClick={() => onClick(!isSelected)}
          sx={{ width: '100%', minWidth: 0, overflow: 'hidden' }}
        >
          <CheckBox isSelected={isSelected} supplementalInfo={supplementalInfo}>
            {children}
          </CheckBox>
        </Box>
      ) : (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            minWidth: 0,
            overflow: 'hidden',
          }}
        >
          {typeof children === 'string' ? (
            <SimpleTooltip title={children} enterDelay={500}>
              <Box
                component="span"
                sx={{
                  flex: 1,
                  minWidth: 0,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  display: 'block',
                  cursor: 'default',
                }}
              >
                {children}
              </Box>
            </SimpleTooltip>
          ) : (
            <Box
              component="span"
              sx={{
                flex: 1,
                minWidth: 0,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {children}
            </Box>
          )}
          {supplementalInfo && (
            <Box component="span" sx={{ flexShrink: 0, ml: 'auto', mr: '0.25rem' }}>
              {supplementalInfo}
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};

export default UWRatingOptionLineItemName;

interface CheckBoxProps {
  children: React.ReactNode;
  isSelected: boolean;
  supplementalInfo?: React.ReactNode;
}

const CheckBox = ({
  isSelected,
  children,
  supplementalInfo,
}: CheckBoxProps) => {
  if (isSelected) {
    return (
      <CoverageCheckbox.Selected
        label={children}
        rulesAndFactors={supplementalInfo}
      />
    );
  }

  return (
    <CoverageCheckbox.Available
      label={children}
      rulesAndFactors={supplementalInfo}
    />
  );
};
